import gql from 'graphql-tag';

export default gql`
  fragment DialogFragment on Dialog {
    _id
    type
    dialogUsers {
      countOfUnreadMessages
      user {
        _id
        firstName
        lastName
      }
    }
    data {
      course {
        _id
        title
      }
      courseCategory {
        _id
        title
      }
      lesson
      isCommonDialog
    }
    creator {
      login
      _id
      firstName
      isActivated
      lastName
      isSubscribedToPosts
      email
      phone
      avatar {
        path
      }
      role
    }
  }
`;
